/*
    响应处理
*/
import { Message } from 'element-ui';

export default class ResponseHandler {
    //网络连接失败
    public netConnectionFail(error: any): Promise<any> {
        // Message.closeAll();
        Message.error("网络请求错误，请重试");
        return Promise.reject(error);
    }
}
